import { Delete } from '@mui/icons-material';
import { TextField, List, ListItem, ListItemText, IconButton, Typography, Divider } from '@mui/material';
import React, { useState, useContext } from 'react';

import { KickOffContext } from '@/Contexts/KickOff';
import { isValidEmail } from '@/utils/userInformation';

const EmailsList: React.FC = () => {
  const { sharedWithEmails, setSharedWithEmails } = useContext(KickOffContext);
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();

    const email = inputValue.trim();
    if (!email) return;

    if (!isValidEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    if (sharedWithEmails.includes(email)) {
      setError('This email has already been added');
      return;
    }

    setSharedWithEmails([...sharedWithEmails, email]);
    setInputValue('');
    setError('');
  };

  const handleRemove = (index: number) => {
    setSharedWithEmails(sharedWithEmails.filter((_, i) => i !== index));
  };

  return (
    <>
      <TextField
        label="Share With"
        variant="outlined"
        fullWidth
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          if (error) setError('');
        }}
        onKeyDown={handleKeyDown}
        error={!!error}
        helperText={error || "Hit 'Enter' to add an email"}
        size="small"
      />

      {sharedWithEmails.length > 0 && (
        <>
          <Divider sx={{ my: 1.5 }} />
          <Typography variant="caption" color="text.secondary">
            Recipients ({sharedWithEmails.length})
          </Typography>
          <List dense disablePadding>
            {sharedWithEmails.map((email, index) => (
              <ListItem
                key={`email-${index}`}
                disableGutters
                sx={{ borderBottom: '1px solid #f0f0f0', py: 0.5 }}
                secondaryAction={
                  <IconButton size="small" onClick={() => handleRemove(index)}>
                    <Delete fontSize="small" color="error" />
                  </IconButton>
                }
              >
                <ListItemText primary={email} slotProps={{ primary: { variant: 'body2' } }} />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </>
  );
};

export default EmailsList;
